import { Contracts, ContractsState, ContractDetails } from './contracts.model';
import { WelcomeKisaStatus } from '../agreements/agreements.model';

const reducers = {
  storeWelcomeKisa: (state: ContractsState, status: WelcomeKisaStatus) => ({
    ...state,
    welcomeKISA: status
  }),
  storeAllContracts: (state: ContractsState, contracts: Contracts) => ({
    ...state,
    contracts: contracts.contracts,
    totalDebtAmountOnAllContractsByCurrency:
      contracts.totalDebtAmountOnAllContractsByCurrency || null,
    welcomeKISA: contracts.welcomeKISA
  }),
  storeContractDetails: (
    state: ContractsState,
    contract: ContractDetails,
    contractId: number
  ) => ({
    ...state,
    [contractId]: contract
  })
};

export default reducers;
